import { TemplateRef } from "@angular/core";
//import { ContextMenuComponent } from "ngx-contextmenu";
import { AppDatatableColumnMode } from "../enums";
import { StringAnyMap } from "../../../client-core/api-interfaces/keyvalue-maps.interface";

export class AppDatatableConfigOptions {

    public static readonly SubItemContainerCssClass:string = "datatable-sub-item-container-row";

    public columns: Array<any>;
    public idProp: string;
    public editable: boolean;
    public compact: boolean;
    public showRowNumbers: boolean;
    public reorderable: boolean;
    public fromRelation: string;
    public toRelation: string;
    public treeLayout: boolean;
    public treeColumnIndex: number;
    public externalSorting: boolean;
    public externalPaging: boolean;
    public columnMode: string;
    public scrollbarVertical: any;
    public scrollbarHorizontal: any;
    public exapandLocally: boolean; /*if set to true, the exapand will not call raise event and data is expected to be preloaded*/
    public expandAllOnInit: boolean;
    public headerHeight: any;
    public footerHeight: any;
    public rowHeight: any;
    public loadingIndicator: any;
    public selectionType: string;
    public rowExpandable: boolean;
    public rowDetailHeight: number;
    public rowDetailTemplate: TemplateRef<any>;
    public groupRowsBy: any;
    public groupExpansionDefault: boolean;
    public rowGrouperAllowToggle: boolean;
    public rowGrouperHeight: number;
    public rowGrouperLabelGetter: any;
    public hasHeaderFilters: boolean;
    public pageSizeOptions: Array<number>;
    public showPageSizeOptions: boolean;
    public showSearchTermControl: boolean;
    public showExpandHideAllControl: boolean;

    // ngx-contextmenu config properties
    //public contextMenuComponent: ContextMenuComponent;
    public contextMenuItems: Map<string, StringAnyMap>;
    public getRowClass: any;
    
    constructor() {
        // initialize defaults
        this.columns = new Array<any>();
        this.contextMenuItems = new Map<string, StringAnyMap>();
        //this.contextMenuComponent = undefined;
        this.idProp = "id";
        this.editable = true;
        this.rowExpandable = false;
        this.compact = false;
        this.showRowNumbers = false;
        this.reorderable = false;
        this.treeLayout = false;
        this.treeColumnIndex = 0;
        this.externalPaging = true;
        this.externalSorting = true;
        this.columnMode = AppDatatableColumnMode.FORCE;
        this.scrollbarHorizontal = false;
        this.scrollbarVertical = false;
        this.fromRelation = undefined;
        this.toRelation = undefined;
        this.headerHeight = "auto";
        this.footerHeight = "auto";
        this.rowHeight = "auto";
        this.selectionType = "single";
        this.rowDetailHeight = 0;
        this.rowGrouperHeight = 0;
        this.rowGrouperAllowToggle = true;
        this.groupExpansionDefault = false;
        this.hasHeaderFilters = false;
        this.pageSizeOptions = [10, 25, 50, 100, 150];
        this.showPageSizeOptions = false;
        this.showSearchTermControl = false;
        this.getRowClass = function (row) {
            //no-op
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/datatable/models/config-options.model.ts